import { MOKA_INVENTORY_API } from '../constants';

export const LIBRARY_BRANDS = (outletId, id = null) => {
  return id
    ? `${MOKA_INVENTORY_API}/v1/brands/${id}/outlets/${outletId}`
    : `${MOKA_INVENTORY_API}/v1/brands/outlets/${outletId}`;
};

export const V1_BRAND_BY_ID = (id) => `${MOKA_INVENTORY_API}/v1/brands/${id}`;
export const BRAND_ALL_OUTLETS = (outletId) =>
  `${MOKA_INVENTORY_API}/v1/brands/outlets/${outletId}/all`;
